import { Breadcrumb } from '@lego/klik-ui';
import { Link as ReactRouterLink } from 'react-router-dom';

type Crumb = {
  label: string;
  path?: string;
};

type Props = {
  crumbs: Crumb[];
};

export const BreadCrumb = (props: Props) => {
  return (
    <Breadcrumb p={3} size={{ base: 'md', md: 'lg' }}>
      {props.crumbs.map((crumb, index) => (
        <Breadcrumb.Item alignItems="baseline" key={crumb.label}>
          <Breadcrumb.Link
            as={ReactRouterLink}
            fontWeight={index === props.crumbs.length - 1 ? 'bold' : 'normal'}
            p={0}
            to={crumb.path}
          >
            {crumb.label}
          </Breadcrumb.Link>
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};
